export default __webpack_public_path__ + "static/media/ruvim-noga.dd3230ba.jpg";